import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

const SESSION_ID_COOKIE_KEY = 'mydocs.sessionId';
const SESSION_ID_PARAM_KEY = 'sessionId';
const ORDER_NUMBER_COOKIE_KEY = 'mydocs.orderNumber';
const ORDER_NUMBER_PARAM_KEY = 'orderNumber';
const COOKIE_TTL_MS = 10 * 10 * 10 * 60 * 60;
@Injectable()
export class ParametersService {
  constructor(private activatedRoute: ActivatedRoute) {
    if (this.shouldUpdateCookie(SESSION_ID_COOKIE_KEY, SESSION_ID_PARAM_KEY)) {
      this.setCookie(
        SESSION_ID_COOKIE_KEY,
        <string>(
          this.activatedRoute.snapshot.queryParamMap.get(SESSION_ID_PARAM_KEY)
        )
      );
    }
    if (
      this.shouldUpdateCookie(ORDER_NUMBER_COOKIE_KEY, ORDER_NUMBER_PARAM_KEY)
    )
      this.setCookie(
        ORDER_NUMBER_COOKIE_KEY,
        <string>(
          this.activatedRoute.snapshot.queryParamMap.get(ORDER_NUMBER_PARAM_KEY)
        )
      );
  }

  public getCurrentSessionId(): string {
    return (
      this.activatedRoute.snapshot.queryParams[SESSION_ID_PARAM_KEY] ??
      this.getCookie(SESSION_ID_COOKIE_KEY)
    );
  }

  public getCurrentOrderNumber(): string {
    return (
      this.activatedRoute.snapshot.queryParams[ORDER_NUMBER_PARAM_KEY] ??
      this.getCookie(ORDER_NUMBER_COOKIE_KEY)
    );
  }

  public resetSessionIdCookie(): void {
    this.resetCookie(SESSION_ID_COOKIE_KEY);
  }
  public resetOrderNumberCookie(): void {
    this.resetCookie(ORDER_NUMBER_COOKIE_KEY);
  }

  private resetCookie(key: string): void {
    this.setCookie(key, '', new Date(0));
  }

  /**
   * true if cookie doesn't exists or if urlParameter is defined and different from cookie stored
   * @param key
   * @param param
   * @returns boolean
   */
  private shouldUpdateCookie(key: string, param: string): boolean {
    const urlParam =
      this.activatedRoute.snapshot.queryParamMap.get(param) ?? '';
    return <boolean>(
      (!this.getCookie(key) || (urlParam && urlParam !== this.getCookie(key)))
    );
  }

  private setCookie(key: string, value: string, expires?: Date): void {
    if (!expires) {
      expires = new Date();
      expires.setTime(expires.getTime() + COOKIE_TTL_MS);
    }

    let cookieExpiration = 'expires=' + expires.toUTCString();
    document.cookie = key + '=' + value + ';' + cookieExpiration + '; path=/';
  }

  private getCookie(key: string): string {
    // decode any special character from urlsafe back to utf-8
    const decodedCookie = decodeURIComponent(document.cookie);
    return this.readValueFromCookieString(decodedCookie, key);
  }

  private readValueFromCookieString(decodedCookie: string, key: string) {
    const cookieValue =
      decodedCookie
        .split(';')
        .find((cookie) => cookie.indexOf(key) !== -1)
        ?.split('=')[1] ?? '';

    return cookieValue !== 'null' ? cookieValue : '';
  }
}
